import globals from '../globals';
export default {
    data() {
        return {
            warning_msg:"",
        }
    },
    methods: { 
        async createScheduleMeetings(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_EMAIL_URL + "/reminders/meeting/create_meeting", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                }
            })
        },
        async updateScheduleMeetings(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.patch(globals.CRM_EMAIL_URL + "/reminders/meeting/update_meeting", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                }
            })
        },
        async getScheduleMeetingList(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_EMAIL_URL + "/reminders/meeting/list?product_name=CRM", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){

                }
            })
        },
        async getScheduleMeetingById(meeting_id) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_EMAIL_URL + `/reminders/meeting/get?id=${meeting_id.id}&product_name=CRM`);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){

                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async deleteScheduleMeeting(params){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.delete(globals.CRM_EMAIL_URL + `/reminders/meeting/delete?product_name=CRM`, {
                        data: params
                    })
                    // let response = await this.$http.delete(globals.CRM_EMAIL_URL + "/reminders/meeting/delete?product_name=CRM", params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async MeetingCallreports(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.patch(globals.CRM_EMAIL_URL + "/reminders/meeting/update_meeting/reminder_call_reports", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                        this.warning_msg = response.data.reason
                        // this.$refs.warning_modal.open();
                        setTimeout(() => {
                            // this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                }
            })
        },
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/scheduleMeeting.js